import { render, staticRenderFns } from "./DialogPatientSearchMail.vue?vue&type=template&id=66c604c8&scoped=true"
import script from "./DialogPatientSearchMail.vue?vue&type=script&lang=js"
export * from "./DialogPatientSearchMail.vue?vue&type=script&lang=js"
import style0 from "./DialogPatientSearchMail.vue?vue&type=style&index=0&id=66c604c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c604c8",
  null
  
)

export default component.exports